import { Injectable } from '@angular/core';
import { JobEffects } from '../store/effects/job.effects';
import { CandidateSearchReducer } from '../store/candidate-search/candidate-search.reducer';
import { CandidateEffects } from '../store/effects/candidate.effects';
import { MarginCalculatorEffects } from '../store/effects/margin-calculator.effects';
import { MarginSetupReducer } from '../store/margin-setup/margin-setup.reducer';
import { AdditionalRatesEffects } from '../store/effects/additional-rates.effects';
import { AdditionalRatesReducer } from '../store/additional-rates/additional-rates.reducer';
import { MarginExpensesEffects } from '../store/effects/margin-expenses.effects';
import { MarginExpensesReducer } from '../store/margin-expenses/margin-expenses.reducer';

@Injectable({ providedIn: 'root' })
export class LocumsMarginCalculatorInitializerService {
    constructor(
        protected readonly marginCalculatorEffects: MarginCalculatorEffects,
        protected readonly jobEffects: JobEffects,
        protected readonly candidateSearchReducer: CandidateSearchReducer,
        protected readonly candidateEffects: CandidateEffects,
        protected readonly marginSetupReducer: MarginSetupReducer,
        protected readonly additionalRatesEffects: AdditionalRatesEffects,
        protected readonly additionalRatesReducer: AdditionalRatesReducer,
        protected readonly marginExpensesEffects: MarginExpensesEffects,
        protected readonly marginExpensesReducer: MarginExpensesReducer
    ) {}
}
